<app-tooth-picker (notifySave)="onNotifySave($event, '175927C6-EC08-478F-8527-E6A1AB88CC96')" *ngIf="actionId === '175927C6-EC08-478F-8527-E6A1AB88CC96'" data-cy="forms-item-modal-tooth-picker"></app-tooth-picker>
